/* eslint-disable max-len */
export const legendMeasurementsOokla = {
	measurementRSRP: 'RSRP (100m)',
	measurementRSRQ: 'RSRQ (100m)',
};

const infoServiceLevelGood = 'You can expect a reliable connection for email and the internet using a 4G phone, laptop or tablet with very High Speeds.';
const infoServiceLevelVariable = 'You can expect a reasonable connection for browsing the internet, using a 4G phone, laptop or tablet, with sufficient data Speeds.';
const infoServiceLevelNoService = 'It is unlikely you will be able to achieve internet connection. However, you may achieve service if 3G Coverage is available.';

export const RSRP_GOOD_MAX = -65;
export const RSRP_GOOD_MIN = -105;
export const RSRP_VARIABLE_MAX = -106;
export const RSRP_VARIABLE_MIN = -113;
export const RSRP_NO_SERVICE_MAX = -114;

export const RSRQ_GOOD_MAX = -4;
export const RSRQ_GOOD_MIN = -7;
export const RSRQ_VARIABLE_MAX = -8;
export const RSRQ_VARIABLE_MIN = -13;
export const RSRQ_NO_SERVICE_MAX = -14;

const RSRP_LEVEL_GOOD = `${RSRP_GOOD_MAX}dBm to ${RSRP_GOOD_MIN}dBm`;
const RSRP_LEVEL_VARIABLE = `${RSRP_VARIABLE_MAX}dBm to ${RSRP_VARIABLE_MIN}dBm`;
const RSRP_LEVEL_NO_SERVICE = `≤ ${RSRP_NO_SERVICE_MAX}dBm`;

const RSRQ_LEVEL_GOOD = `${RSRQ_GOOD_MAX}dB to ${RSRQ_GOOD_MIN}dB`;
const RSRQ_LEVEL_VARIABLE = `${RSRQ_VARIABLE_MAX}dB to ${RSRQ_VARIABLE_MIN}dB`;
const RSRQ_LEVEL_NO_SERVICE = `≤ ${RSRQ_NO_SERVICE_MAX}dB`;

interface IGetLegendInfoReturn {
	title?: string;
	textServiceLevelGood?: string;
	textServiceLevelVariable?: string;
	textServiceLevelNoService?: string;
	infoServiceLevelGood?: string;
	infoServiceLevelVariable?: string;
	infoServiceLevelNoService?: string;
}

export const getLegendInfo = (measurementName: string): IGetLegendInfoReturn => {
	switch (true) {
		case measurementName === legendMeasurementsOokla.measurementRSRP: {
			return {
				title: 'RSRP levels',
				textServiceLevelGood: RSRP_LEVEL_GOOD,
				textServiceLevelVariable: RSRP_LEVEL_VARIABLE,
				textServiceLevelNoService: RSRP_LEVEL_NO_SERVICE,
				infoServiceLevelGood,
				infoServiceLevelVariable,
				infoServiceLevelNoService,
			};
		}

		case measurementName === legendMeasurementsOokla.measurementRSRQ: {
			return {
				title: 'RSRQ levels',
				textServiceLevelGood: RSRQ_LEVEL_GOOD,
				textServiceLevelVariable: RSRQ_LEVEL_VARIABLE,
				textServiceLevelNoService: RSRQ_LEVEL_NO_SERVICE,
				infoServiceLevelGood,
				infoServiceLevelVariable,
				infoServiceLevelNoService,
			};
		}

		default:
			return {};
	}
};
